<div class="relative" [class]="className()">
  @if (label()) {
    <label
      [for]="label()"
      class="absolute text-xs -top-2 left-3 z-10 bg-white px-1 rounded-md transition duration-300 font-medium text-neutral-700"
      >{{ label() }}</label
    >
  }
  <select
    [id]="label()"
    [ngModel]="value"
    (change)="onSelectionChange($event)"
    [disabled]="isDisabled"
    [class.opacity-50]="isDisabled"
    [class.cursor-not-allowed]="isDisabled"
    class="h-full py-2 px-3 block border border-neutral-700 rounded-lg sm:text-sm focus:ring-0 focus:outline-primary-80 appearance-none bg-white placeholder:text-neutral-700 nth-*:text-neutral-700 min-w-full bg-[url('/assets/chevron-down.svg')] bg-size-[16px] bg-position-[right_8px_center] bg-no-repeat pr-7 max-w-full text-ellipsis">
    <option value="" disabled selected>{{ placeholder() }}</option>
    @for (option of options(); track option.value) {
      <option [value]="option.value">
        {{ option.label }}
      </option>
    }
  </select>
</div>
